import {useContext} from 'react'
import {UserContext} from './UserProvider'

export const useGetUser = () => {
  const res = useContext(UserContext)
  return {...res}
}
